import { useEffect, useState } from "react";
import BookDTO from "../../DTO/BookDTO";
import blackLogo from "../../../src/static/gfx/lubbers-logo.svg"
import whiteLogo from "../../../src/static/gfx/lubbers-logo-white.svg"
import colorLogo from "../../../src/static/gfx/lubbers-logo-yellow.svg"

export default function BrandingDisplay(props: {
  scheme: string,
  hide?: boolean,
  preview?: boolean,
  book?: BookDTO,
  reload?: number,
}) {
  const [scheme, setScheme] = useState(props.scheme)
  const [hide, setHide] = useState(props.hide)
  const [fileUrl, setFileUrl] = useState('')


  function loadFileInfo(scheme: string) {
    if (props.book) {
      const prop = props.book.getProp('branding', scheme)
      if (prop && prop.file) {
        setFileUrl(prop.file.getURL())
      }
      
    }
  }
  
  useEffect(() => {
    setHide(props.hide)
  }, [props.hide])
  useEffect(() => {
    loadFileInfo(props.scheme)
    setScheme(props.scheme)
  }, [props.reload, props.scheme])


  function getBrandUrl() {
    if (fileUrl) {
      return fileUrl
    }
    switch(scheme) {
      case 'black':
        return blackLogo
      case 'white':
        return whiteLogo
      case 'color':
        return colorLogo
    }
    return blackLogo
  }


  function getStyle() {
    return {
      backgroundImage: `url("${getBrandUrl()}")`
    }
  }

  function brandingClass () {
    let className = 'branding no-pointer-events'
    className += props.preview ? '' : ' brandingPosition'
    className += hide ? ' hide' : ''
    return className
  }

  return <div className={brandingClass()}>
      <div className="goldenAspect">
        <div
          className={`brandImg ${scheme}OLDImg`}
          style={getStyle()}
        ></div>
      </div>
    </div>
}
